import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InputAdornment, Box, useMediaQuery } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { DployTextField } from "@ploy-ui/form-fields";
import { useState } from "react";
import { useIntl } from "react-intl";
import { DployAutocomplete } from "@ploy-ui/form-fields";
import React from "react";
import useBuyoutStyles from "../BuyoutStyles";
import { ProfileResource, AllApplicationsSettingsResource } from "@ploy-lib/rest-resources";
import { useResource } from "rest-hooks";
import { useField } from "formik";
import { isNotNull } from "@ploy-lib/core";
import { messages } from "../messages";
const messageDict = [
    messages.appNo,
    messages.reg,
    messages.chassis,
    messages.searchCustomerName
];
const BuyoutSearchBar = (props) => {
    const { searchFilter, id } = props;
    const intl = useIntl();
    const { canAccessAll } = useResource(AllApplicationsSettingsResource.detail(), {});
    const profile = useResource(ProfileResource.detail(), {});
    const isMobile = useMediaQuery("(max-width:600px)");
    const allItem = { value: "", label: intl.formatMessage(messages.All) };
    const items = [
        { value: profile.salespersonId, label: intl.formatMessage(messages.Mine) },
        canAccessAll ? allItem : null
    ].filter(isNotNull);
    const [field, , form] = useField(id);
    React.useEffect(() => {
        if (field.value !== allItem.value &&
            items.some(x => x.value === allItem.value)) {
            form.setValue(allItem.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const item = items.find(x => x.value === field.value) ?? allItem;
    const [messageIndex, setMessageIndex] = useState(0);
    const [searchVal, setSearchVal] = useState("");
    // Cycle placeholder text every 2 seconds
    React.useEffect(() => {
        const timer = setInterval(() => {
            setMessageIndex(idx => (idx + 1) % messageDict.length);
        }, 2000);
        return () => clearInterval(timer);
    }, []);
    // Call searchFilter whenever searchVal or id changes
    React.useEffect(() => {
        searchFilter(searchVal, field.value);
    }, [searchVal, field.value, searchFilter]);
    const classes = useBuyoutStyles();
    return (_jsx(Box, { className: classes.searchBox, children: (() => {
            const inputPropsAutocomplete = {
                style: {
                    height: isMobile ? 36 : 48,
                    borderRadius: 48,
                    minWidth: isMobile ? 100 : 220,
                    paddingLeft: 16,
                    border: "1px solid #00002B"
                },
                disableUnderline: true
            };
            const inputPropsTextField = {
                style: {
                    height: isMobile ? 36 : 48,
                    minWidth: isMobile ? 100 : 220
                },
                endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(Search, {}) }))
            };
            return (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.searchAutocompleteBox, children: _jsx(DployAutocomplete, { variant: "standard", items: items, getItemLabel: item => item.label, getItemValue: item => item.value || "", ...field, value: item, onChange: (e, item) => form.setValue(item.value), readonly: items.length <= 1, multiple: false, disableClearable: true, searchable: false, AutocompleteProps: {
                                getOptionSelected: (option, value) => option.value === value.value
                            }, fullWidth: true, InputProps: inputPropsAutocomplete }) }), _jsx(DployTextField, { onChange: e => setSearchVal(e.target.value), placeholder: intl.formatMessage(messageDict[messageIndex]), fullWidth: true, InputProps: inputPropsTextField, className: classes.searchTextBox })] }));
        })() }));
};
export { BuyoutSearchBar };
//# sourceMappingURL=BuyoutSearchBar.js.map